import React from "react";
import "../styles/CursorToggleButton.css";

function CursorToggleButton({ isActive, onToggle }) {
  return (
    <button
      type="button"
      className={`cursor-toggle${isActive ? " cursor-toggle--active" : ""}`}
      onClick={onToggle}
      aria-pressed={isActive}
      aria-label={
        isActive ? "Turn off custom cursor" : "Turn on custom cursor"
      }
      title={isActive ? "Turn off custom cursor" : "Turn on custom cursor"}
    >
      <img
        src="/rose.png"
        alt=""
        className="cursor-toggle__icon"
        aria-hidden="true"
      />
    </button>
  );
}

export default CursorToggleButton;
